import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { makeStyles, Typography, TextField, Grid } from '@material-ui/core';
import { appProfileSelector } from 'redux/selectors';
import { setLoading } from 'redux/actions/app';
import { useSelector, useDispatch } from 'react-redux';
import * as API from 'services/api';
import { isEmail } from 'utils/validations';
import PropTypes from 'prop-types';
import { showMessage } from 'utils';
import CommonModal from 'components/Modals/CommonModal';

const useStyles = makeStyles(theme => ({
    label: {
        fontWeight: 'bold',
        color: theme.palette.app.primary,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(0.5)
    }
}));


const initialized = {
    firstName: '',
    lastName: '',
    email: ''
}

//SPA-663
const companyFieldsFromProfile = (profile = {}) => ({
    company: profile.company || '',
    address: profile.address || '',
    zipCode: profile.zipCode || '',
    city: profile.city || '',
    country: profile.country || '',
});

const ContactModal = ({ intl: { formatMessage }, open: visible, onClose }) => {
    const classes = useStyles();
    const profile = useSelector(appProfileSelector);
    const dispatch = useDispatch();
    const [user, setUser] = useState(initialized);

    useEffect(() => {
        if (visible) {
            setUser({
                ...initialized,
                ...companyFieldsFromProfile(profile),
            });
        }
    }, [visible, profile]);

    const onSubmitRequest = () => {
        dispatch(setLoading(true));
        // Always sync company / address from the client profile at send time
        const payload = {
            ...user,
            ...companyFieldsFromProfile(profile),
        };
        API.createUser(payload).then(res => {
            dispatch(setLoading(false));
            if (res.code == 201) {
                showMessage({
                    message: 'Submitted successfully!',
                    type: 'success'
                });
                onClose(true)
                return
            }
            showMessage({
                message: res.message || 'Failed!',
                type: 'warning'
            });
        }).catch(() => {
            showMessage({
                message: 'The email already exists!',
                type: 'warning'
            });
            dispatch(setLoading(false));
        });
    }

    const btnDisabled = !isEmail(user.email) || !user.firstName || !user.lastName;

    return (
        <CommonModal
            open={!!visible}
            onClose={onClose}
            title="Inviter un utilisateur"
            buttonLabel={formatMessage({ id: "applications.contact.submit" })}
            btnDisabled={btnDisabled}
            onSubmit={onSubmitRequest}
        >
            <Grid container spacing={1}>
                {
                    Object.keys(initialized).map(field => <Grid key={field} item xs={12}>
                        <Typography className={classes.label}>{formatMessage({ id: "contact.field." + field })}<span style={{ color: '#DF7C70' }}>*</span></Typography>
                        <TextField
                            required
                            fullWidth
                            value={user[field]}
                            onChange={e => {
                                e.persist();
                                setUser(prev => ({
                                    ...prev,
                                    [field]: e.target.value
                                }))
                            }}
                            variant="outlined"
                        />
                    </Grid>)
                }
            </Grid>
        </CommonModal>
    );
};
ContactModal.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }),
    open: PropTypes.bool,
    onClose: PropTypes.func
};
export default injectIntl(ContactModal);


